import { axios, blueApi } from '@/axios.config';
import { mockAdapter } from '@/mocks/axiosMockAdapter.config';
import { setUserToSentry } from '@/sentry.config';
import { sortSpecifyOrder } from '@/lib/sorter';

export const state = {
  data: {},
};

export const actions = {
  /**
   * Get user information.
   * @returns {Promise<AxiosResponse<any>>}
   */
  fetchUser({ commit }) {
    const url = `/user`;

    mockAdapter(axios, 'get', url, 'getUser', 200);

    return axios
      .get(url)
      .then(res => {
        commit('USER_SUCCESS', res.data, { root: true });
        commit('updateBasicUserInfo', res.data, { root: true });
        commit('updateUser', res.data);

        // Dev Tools
        commit('devTools/setFunctions', res.data, { root: true });
        commit('devTools/setLocale', res.data, { root: true });

        // Set user data to Sentry.
        setUserToSentry(res.data);
      })
      .catch(err => {
        throw { response: err.response };
      });
  },

  fetchUserLogo({ commit }) {
    return axios
      .get('/user/logo')
      .then(res => {
        if (res.data.status === 'error') {
          throw res.data.reason;
        }

        if (res.data.status === 'success') {
          commit('USER_LOGO_SUCCESS', res.data.data, { root: true });
        }
      })
      .catch(() => {});
  },

  fetchAccessGroup({ commit, state }) {
    return blueApi
      .get(`/billing/v1/accessgroups/${state.data.billinggroup_id}`)
      .then(res => {
        commit('setBillingGroups', res.data.accessGroup.billingGroups);
      })
      .catch(err => {
        throw { response: err.response };
      });
  },
};

export const mutations = {
  updateUser(state, data) {
    const isSSO = (data.sub_username || '').includes('SSO/');
    state.data = {
      ...data,
      resource_type: data.resource_type || 'account',
      is_sso: isSSO,
    };
  },

  setBillingGroups(state, billingGroups) {
    state.data = {
      ...state.data,
      billingGroups,
    };
  },
};

export const getters = {
  //getUserResourceType(state) {
  //  return state.data.resource_type ? state.data.resource_type : 'account';
  //},

  getUserName(state) {
    return state.data.sub_username ? state.data.sub_username : state.data.mail_address;
  },

  getUserId(state) {
    return state.data.user_id ? state.data.user_id : '';
  },

  getCompanyName(state) {
    return state.data.company_name ? state.data.company_name : '-';
  },

  getBillingGroupName(state) {
    return state.data.billinggroup_name ? state.data.billinggroup_name : '';
  },

  getBillingGroupId(state) {
    return state.data.billinggroup_id ? state.data.billinggroup_id : '';
  },

  getBillingGroups(state) {
    return state.data.billingGroups ? state.data.billingGroups : [];
  },

  getUserEmail(state) {
    return state.data.mail_address ? state.data.mail_address : '';
  },

  getLocale(state) {
    const userSetting = state.data.user_setting;
    if (!userSetting) return 'en';

    return userSetting ? userSetting.language : 'en';
  },

  getCostType(state) {
    return state.data.display_cost ? state.data.display_cost : 'unblended_cost';
  },

  getMeta(state) {
    return state.data.meta ? state.data.meta : {};
  },

  getReportCostType(state, getters) {
    const costType = getters.getCostType;

    if (costType === 'true_unblended_cost') {
      return 'mobingi';
    } else {
      return 'original';
    }
  },

  /**
   * Resource types
   * @param state
   * @return {Array}
   */
  getResourceTypes(state) {
    const resourceType = state.data.resource_type;
    let resourcesType = state.data.resources_type;

    if (!resourcesType) {
      return [resourceType];
    }

    resourcesType = sortSpecifyOrder(resourcesType, null, ['account', 'tag']);

    return resourcesType;
  },

  isSSO(state) {
    return state.data.is_sso;
  },

  isAccessGroup(state) {
    return state.data.access_group ? state.data.access_group : false;
  },
};
